module.exports = __webpack_public_path__ + "img/loadding.1df8df97.gif";